import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsDiasporaComponent } from './simple-icons-diaspora.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsDiasporaComponent ],
    exports:      [ SimpleIconsDiasporaComponent ],
    bootstrap:    []
})
export class SimpleIconsDiasporaModule {}
